// Components/Common/ComingSoonLite.jsx
import React from 'react';
import { FiLock } from 'react-icons/fi';

const ComingSoonLite = ({
  title = 'Smart Suggestions',
  subtitle = 'AI insights and next actions will land here.',
  phaseLabel = 'Phase 2',
  children,
  className = '',
}) => (
  <div className={`csl-wrap ${className}`} aria-disabled="true">
    <div className="csl-content">{children}</div>

    <div className="csl-overlay">
      <div className="csl-card">
        <div className="csl-icon"><FiLock /></div>
        <div className="csl-title">{title}</div>
        <div className="csl-sub">{subtitle}</div>
        <span className="csl-pill">Coming {phaseLabel}</span>
      </div>
    </div>
  </div>
);

export default ComingSoonLite;
